<template>
  <div class="hms-page">
    <Navigation />
    <div class="container hms-page-body">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="d-flex align-items-center gap-3">
          <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="hms-back"><i class="mdi mdi-arrow-left"></i></a>
          <h4 class="m-0"><i class="mdi mdi-food-apple me-2"></i>SAM / MAM Register</h4>
        </div>
        <button class="hms-btn hms-btn-blue" @click="load"><i class="mdi mdi-refresh"></i></button>
      </div>

      <div class="hms-grid-4 mb-3">
        <div class="hms-kpi"><div class="hms-kpi-lbl">OTP active</div><div class="hms-kpi-num">{{ stats.otp_active || 0 }}</div></div>
        <div class="hms-kpi"><div class="hms-kpi-lbl">SC inpatient</div><div class="hms-kpi-num">{{ stats.sc_active || 0 }}</div></div>
        <div class="hms-kpi"><div class="hms-kpi-lbl">MAM active (SFP)</div><div class="hms-kpi-num">{{ stats.mam_active || 0 }}</div></div>
        <div class="hms-kpi"><div class="hms-kpi-lbl">Cured</div><div class="hms-kpi-num hms-good">{{ stats.cured || 0 }}</div></div>
      </div>
      <div class="hms-grid-4 mb-3">
        <div class="hms-kpi"><div class="hms-kpi-lbl">Defaulted</div><div class="hms-kpi-num hms-warn">{{ stats.defaulted || 0 }}</div></div>
        <div class="hms-kpi"><div class="hms-kpi-lbl">Died</div><div class="hms-kpi-num hms-bad">{{ stats.died || 0 }}</div></div>
        <div class="hms-kpi"><div class="hms-kpi-lbl">Non-responder</div><div class="hms-kpi-num hms-bad">{{ stats.non_responder || 0 }}</div></div>
        <div class="hms-kpi"><div class="hms-kpi-lbl">Total ever</div><div class="hms-kpi-num">{{ stats.total || 0 }}</div></div>
      </div>

      <div class="d-flex gap-2 mb-2">
        <select v-model="statusFilter" class="hms-input" @change="load" style="max-width:220px">
          <option value="">All statuses</option>
          <option value="active">Active</option>
          <option value="cured">Cured</option>
          <option value="defaulted">Defaulted</option>
          <option value="died">Died</option>
          <option value="non_responder">Non-responder</option>
          <option value="transferred">Transferred</option>
        </select>
      </div>

      <table class="hms-table">
        <thead><tr><th>Patient</th><th>Age now</th><th>Class</th><th>Track</th><th>Enrolled</th><th>Baseline / Latest</th><th>Visits</th><th>Last visit</th><th>Status</th><th></th></tr></thead>
        <tbody>
          <tr v-for="r in rows" :key="r.sam_id" :class="rowClass(r)">
            <td>
              <strong>{{ r.patient_name }}</strong>
              <div class="hms-muted-sm">{{ r.patient_no }}</div>
            </td>
            <td>{{ r.age_months_now }}mo</td>
            <td><span class="hms-pill" :class="classPill(r.classification)">{{ r.classification.replace(/_/g,' ') }}</span></td>
            <td>{{ r.track }}</td>
            <td>{{ formatDate(r.enrolment_date) }}</td>
            <td class="hms-muted-sm">
              {{ r.weight_kg }}kg → {{ r.latest_weight || r.weight_kg }}kg<br>
              MUAC {{ r.muac_cm || '—' }} → {{ r.latest_muac || r.muac_cm || '—' }}
            </td>
            <td>{{ r.visits_count || 0 }}</td>
            <td>{{ formatDate(r.last_visit) || '—' }}</td>
            <td><span class="hms-pill" :class="statusPill(r.status)">{{ r.status }}</span></td>
            <td><a class="hms-btn hms-btn-secondary hms-btn-sm" :href="'#/newborn/' + r.patient_id"><i class="mdi mdi-eye"></i></a></td>
          </tr>
          <tr v-if="!rows.length"><td colspan="10" class="text-center hms-pad hms-muted">No SAM/MAM cases on register.</td></tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Navigation from "@/components/hms-auth/Navigation.vue";
import { executeJson, hms } from "@/api";

export default {
  name: "SamRegister",
  components: { Navigation },
  data() { return { stats: {}, rows: [], statusFilter: '' }; },
  mounted() { this.load(); },
  methods: {
    async load() {
      const r = await executeJson({ function: 'getSamRegister', status: this.statusFilter }, hms);
      if (r.data && r.data.success) { this.rows = r.data.data.rows || []; this.stats = r.data.data.stats || {}; }
    },
    formatDate(d) { if (!d) return ''; const dt = new Date((d+'').replace(' ','T')); return isNaN(dt) ? d : dt.toLocaleDateString(); },
    rowClass(r) { if (r.classification === 'SAM_with_complications') return 'row-action'; if (r.classification === 'SAM_no_complications') return 'row-warn'; return ''; },
    classPill(c) { return ({ SAM_with_complications:'hms-pill-danger', SAM_no_complications:'hms-pill-warn', MAM:'hms-pill-info' })[c] || 'hms-pill-muted'; },
    statusPill(s) { return ({ active:'hms-pill-warn', cured:'hms-pill-success', defaulted:'hms-pill-danger', died:'hms-pill-danger', non_responder:'hms-pill-danger', transferred:'hms-pill-muted', medical_referral:'hms-pill-danger', still_in_program:'hms-pill-info' })[s] || 'hms-pill-muted'; }
  }
};
</script>

<style scoped>
.hms-page-body { padding: 16px 0 32px; }
.hms-back { color: #4a5568; font-size: 20px; text-decoration: none; }
.hms-grid-4 { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
@media (max-width: 900px) { .hms-grid-4 { grid-template-columns: 1fr 1fr; } }
.hms-kpi { background: #fff; border: 1px solid #e2e8f0; border-radius: 8px; padding: 14px; }
.hms-kpi-lbl { font-size: 11px; color: #718096; font-weight: 600; text-transform: uppercase; }
.hms-kpi-num { font-size: 26px; font-weight: 700; color: #2d3748; }
.hms-good { color: #22543d; } .hms-warn { color: #7b341e; } .hms-bad { color: #742a2a; }
.hms-table { width: 100%; border-collapse: collapse; font-size: 12px; }
.hms-table th { background: #f7fafc; padding: 8px; font-weight: 600; color: #4a5568; text-align: left; border-bottom: 1px solid #e2e8f0; }
.hms-table td { padding: 6px 8px; border-bottom: 1px solid #edf2f7; vertical-align: top; }
.hms-pill { display: inline-block; padding: 2px 8px; border-radius: 10px; font-size: 11px; font-weight: 600; text-transform: capitalize; }
.hms-pill-success { background: #c6f6d5; color: #22543d; }
.hms-pill-info    { background: #bee3f8; color: #2a4365; }
.hms-pill-warn    { background: #feebc8; color: #7b341e; }
.hms-pill-danger  { background: #fed7d7; color: #742a2a; }
.hms-pill-muted   { background: #edf2f7; color: #4a5568; }
.hms-muted, .hms-muted-sm { color: #a0aec0; }
.hms-muted-sm { font-size: 11px; }
.hms-pad { padding: 16px; }
.row-warn { background: #fffaf0; } .row-action { background: #fff5f5; }
.hms-input { padding: 7px 10px; border: 1px solid #cbd5e0; border-radius: 6px; font-size: 13px; }
.hms-btn { display: inline-flex; align-items: center; gap: 4px; padding: 7px 12px; border-radius: 6px; border: 1px solid transparent; font-size: 13px; font-weight: 500; cursor: pointer; text-decoration: none; }
.hms-btn-sm { padding: 4px 10px; font-size: 12px; }
.hms-btn-blue { background: #2b6cb0; color: #fff; }
.hms-btn-secondary { background: #edf2f7; color: #2d3748; border: 1px solid #cbd5e0; }
</style>
